import React from "react";

function Header() {
  return (
    <div className="bg-dark text-white text-center">
      <div className="pt-3 pb-3">
        <a href="/" className="text-light">
          <img
            src="./logo.png"
            className="mr-1"
            style={{ width: "25px" }}
            alt="covid-19 screening tool logo care of flaticon.com"
          />
        </a>
        <h1 style={{ fontSize: "1.2rem", display: "inline" }}>
          Covid19 Screening Tool
        </h1>
      </div>
    </div>
  );
}

export default Header;
